
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import MetadataComponent from './MetadataComponent.vue'
import { State, Getter, Action, Mutation } from '../store-helper'
import { qEditorState } from '../stores'

@Component({
  components: {
    MetadataComponent,
  },
})
export default class SidebarMenuComponent extends Vue {

  get showSidebarMenu(){
    return qEditorState.showSidebarMenu
  }

  openSidebarMenu(){
    qEditorState.openSidebarMenu({menu: 'metadata'})
  }

  constructor () {
    super()
  }
}
